var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 7.5H9.5V4.5C9.5 3.95 9.05 3.5 8.5 3.5C7.95 3.5 7.5 3.95 7.5 4.5V7.5H4.5C3.95 7.5 3.5 7.95 3.5 8.5C3.5 9.05 3.95 9.5 4.5 9.5H7.5V12.5C7.5 13.05 7.95 13.5 8.5 13.5C9.05 13.5 9.5 13.05 9.5 12.5V9.5H12.5C13.05 9.5 13.5 9.05 13.5 8.5C13.5 7.95 13.05 7.5 12.5 7.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon_plus.15437ec2e9aeb9e4a585ac6d3808def8.svg";
export { ForwardRef as ReactComponent };